import { useSnapshot } from "valtio";

import React from "react";
import { TFunction, useTranslation } from "react-i18next";

import { kioskStore as store } from "@pages/Kiosk/store";

export type WorkflowAlerType = {
    handleCartChangedCLickEvent(): Promise<void>;
    setIsOrderAlert: React.Dispatch<React.SetStateAction<boolean>>;
    isOrderAlert: boolean;
};

type useOrderSummeryAlertType = {
    onClose: () => void;
    t: TFunction<"translation", undefined>;
    isPrm: boolean;
    actionsButtons: unknown;
};

export default function useOrderSummeryAlert(
    setIsOrderAlert: React.Dispatch<React.SetStateAction<boolean>>
): useOrderSummeryAlertType {
    const {
        isPrm,
        project: {
            template: {
                content: { actionsButtons },
            },
        },
    } = useSnapshot(store);
    const { t } = useTranslation();

    function onClose() {
        setIsOrderAlert(false);
    }
    return {
        onClose,
        isPrm,
        actionsButtons,
        t,
    };
}
